import { render, staticRenderFns } from "./DashBigNumbers.vue?vue&type=template&id=a4fda0f2&scoped=true"
import script from "./DashBigNumbers.vue?vue&type=script&lang=js"
export * from "./DashBigNumbers.vue?vue&type=script&lang=js"
import style0 from "./DashBigNumbers.vue?vue&type=style&index=0&id=a4fda0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fda0f2",
  null
  
)

export default component.exports